enum WebAppNavigationRoutes {
  routeConfigAppBase = "/",
  routeDashboard = "/dashboard",
  routeFloorConfiguration = "/floor",
  routeRoomPlanner = "/room-planner",
  routeRoomConfiguration = "/room-configuration",
  routeRoomMapping = "/room-mapping",
  routeInactiveRooms = "/inactive-rooms",
  routeTeachAndRepeat = "/teach-and-repeat",
  routeConfigAppConfiguration = "/configuration",
  routeConfigAppUpdate = "/update",
  routeServiceApp = "/service",
  routeMissions = "/missions",
  routeScheduler = "/scheduler",
  routeHardware = "/hardware",

  routeCommissioningBase = "/service"
}

export default WebAppNavigationRoutes;
